<template>
  <div class="item-container">
    <!-- 学术精汇/学术综述/百科精选  -->
    <div class="item-no-img" v-if="every.articleType === 0">
      <template v-if="every.type === 0">
        <h2 class="title" @click="handleClick">
          <span class="topping" v-if="every.topping == 1">{{
            every.topping == 1 ? "置顶" : ""
          }}</span>
          <span class="column" v-for="(v, i) in every.channelidsStr" :key="i"
            >[{{ v }}]</span
          >
          <span class="h2-title" v-html="every.title"></span>
          <span class="classificationName" v-if="every.classificationName">{{
            every.classificationName
          }}</span>
        </h2>
        <div class="personal">
          <div class="anther" ref="paperAuthorDom">
            <!-- 第一作者 -->
            <!-- <span
              @click="toAuthor(every, every.firstAuthorId)"
              style="cursor: pointer"
              >{{ every.firstAuthor }}
            </span>
            <span v-if="every.othorAuthor">
              <span v-for="(item,index) in every.othorAuthor.split(',')" :key="index">
                {{ item }}
              </span>
            </span>
            <span v-if="every.author">
              <span v-for="(item,index) in every.author.split(',')" :key="index">
                {{ item }}
              </span>
            </span> -->
            <!-- 其他作者  -->
            <!-- <span v-if="every.authorResultList">
              <span
                v-for="(item, key) in every.authorResultList"
                :key="key"
                @click="toAuthor(every, item.authorId)"
                style="cursor: pointer"
                >{{ item.authorName }}
              </span>
            </span> -->
            <!-- 通讯作者 communicationAuthor -->
            <!-- <span
              @click="toAuthor(every, every.communicationAuthorId)"
              style="cursor: pointer"
              >{{ every.communicationAuthor }}
            </span> -->
            <span
              v-for="item in every.authors"
              :key="item.articleId"
              @click="toAuthor(every, item.authorId)"
              style="cursor: pointer"
              >{{ item.authorName }}
            </span>
          </div>
          <p
            @click="toAuthor(every, every.periodicalId, true)"
            class="period"
            v-if="every.periodical"
          >
            {{ every.periodical }}
            (<span v-if="every.journalsYear">{{ every.journalsYear }}年</span>
            <span v-if="every.journalsVolume"
              >第{{ every.journalsVolume }}卷</span
            >
            <span v-if="every.journalsTerm">第{{ every.journalsTerm }}期</span>)
            <!-- {{
              `${every.periodical} ${every.journalsYear}年第${every.journalsVolume}卷第${every.journalsTerm}期`
            }} -->
          </p>
        </div>
        <div
          class="content"
          v-if="every.artSummary"
          v-html="every.artSummary"
        ></div>
        <ul class="icon">
          <li @click.stop="clickFn('收藏')">
            <img
              v-if="every.isCollect"
              src="@/assets/img/qietu/sc.png"
              alt=""
            />
            <img v-else src="@/assets/img/qietu/kongxin.png" alt="" />
            <span>收藏</span>
          </li>
          <li
            v-for="(item, index) in getIconList"
            :key="index"
            @click.stop="clickFn(item)"
          >
            <img v-lazy="item.iconSrc" alt="" />
            <span>{{ item.iconTitle }}</span>
          </li>
          <li class="share">
            <img src="@/assets/img/qietu/share.png" alt="" />
            <div>分享</div>
            <ul class="share_box">
              <div class="sanjiao"></div>
              <li @mouseover.stop="weChat" class="weChat">
                <img src="@/assets/img/details/WeChat.png" alt="" />
                <div>微信</div>
                <div
                  :id="`WXqrcode${curcer}`"
                  :ref="`WXqrcode${curcer}`"
                  class="ma"
                ></div>
              </li>
              <li @click.stop="weibo">
                <img src="@/assets/img/details/weiBo.png" alt="" />
                <div>新浪微博</div>
              </li>
              <li @mouseover.stop="qq" class="qq">
                <img src="@/assets/img/details/QQ.png" alt="" />
                <div>QQ</div>
                <div
                  :id="`QQqrcode${curcer}`"
                  :ref="`QQqrcode${curcer}`"
                  class="ma"
                ></div>
              </li>
              <li @click.stop="space">
                <img src="@/assets/img/details/qqspace.png" alt="" />
                <div>QQ空间</div>
              </li>
            </ul>
          </li>
        </ul>
      </template>
      <template v-else-if="every.type === 3">
        <h2 class="title" @click="handleClick">
          <span class="topping" v-if="every.topping == 1">{{
            every.topping == 1 ? "置顶" : ""
          }}</span>
          <span class="column" v-for="(v, i) in every.channelidsStr" :key="i"
            >[{{ v }}]</span
          >
          <span class="h2-title" v-html="every.title"></span>
          <span class="classificationName" v-if="every.classificationName">{{
            every.classificationName
          }}</span>
        </h2>
        <div class="personal">
          {{ every.createName }}
        </div>
        <div class="address">
          {{ every.firstAuthor }} - {{ every.firstAuthorUnit }}
        </div>
        <div class="origin-periods">
          <span class="period">
            <span v-if="every.periodical">{{ every.periodical }}-</span>
            <span v-if="every.journalsYear">{{ every.journalsYear }}年</span>
            <span v-if="every.journalsTerm">第{{ every.journalsTerm }}期</span>
            <!-- {{
              `${every.periodical} - ${every.journalsYear}年第${every.journalsTerm}期`
            }} -->
          </span>
          <span class="origin-period">{{
            `原发刊：${every.originalTitle} - ${every.originalPeriod}`
          }}</span>
        </div>
        <ul class="icon">
          <li @click.stop="clickFn('收藏')">
            <img
              v-if="every.isCollect"
              src="@/assets/img/qietu/sc.png"
              alt=""
            />
            <img v-else src="@/assets/img/qietu/kongxin.png" alt="" />
            <span>收藏</span>
          </li>
          <li
            v-for="(item, index) in getIconList"
            :key="index"
            @click.stop="clickFn(item)"
          >
            <img v-lazy="item.iconSrc" alt="" />
            <span>{{ item.iconTitle }}</span>
          </li>
          <li class="share">
            <img src="@/assets/img/qietu/share.png" alt="" />
            <div>分享</div>
            <ul class="share_box">
              <div class="sanjiao"></div>
              <li @mouseover.stop="weChat" class="weChat">
                <img src="@/assets/img/details/WeChat.png" alt="" />
                <div>微信</div>
                <div
                  :id="`WXqrcode${curcer}`"
                  :ref="`WXqrcode${curcer}`"
                  class="ma"
                ></div>
              </li>
              <li @click.stop="weibo">
                <img src="@/assets/img/details/weiBo.png" alt="" />
                <div>新浪微博</div>
              </li>
              <li @mouseover.stop="qq" class="qq">
                <img src="@/assets/img/details/QQ.png" alt="" />
                <div>QQ</div>
                <div
                  :id="`QQqrcode${curcer}`"
                  :ref="`QQqrcode${curcer}`"
                  class="ma"
                ></div>
              </li>
              <li @click.stop="space">
                <img src="@/assets/img/details/qqspace.png" alt="" />
                <div>QQ空间</div>
              </li>
            </ul>
          </li>
        </ul>
      </template>
      <template v-else-if="every.type === 4">
        <h2 class="title" @click="handleClick">
          <span class="topping" v-if="every.topping == 1">{{
            every.topping == 1 ? "置顶" : ""
          }}</span>
          <span class="column" v-for="(v, i) in every.channelidsStr" :key="i"
            >[{{ v }}]</span
          >
          <span class="h2-title" v-html="every.title"></span>
          <span class="classificationName" v-if="every.classificationName">{{
            every.classificationName
          }}</span>
        </h2>
        <div class="personal">
          <div class="anther">
            <span
              @click="toAuthor(every, every.firstAuthorId)"
              style="cursor: pointer"
              >{{ every.firstAuthor }}
            </span>
            <span
              @click="toAuthor(every, every.communicationAuthorId)"
              style="cursor: pointer"
              >{{ every.communicationAuthor }}
            </span>
            <span
              @click="toAuthor(every, every.othornAuthorId)"
              style="cursor: pointer"
              >{{ every.othorAuthor }}</span
            >
          </div>
          <p
            @click="toAuthor(every, every.periodicalId, true)"
            class="period"
            v-if="every.periodical"
          >
            {{
              `${every.periodical} ${every.journalsYear}年第${every.journalsVolume}卷第${every.journalsTerm}期`
            }}
          </p>
        </div>
        <div
          class="content"
          v-if="every.artSummary"
          v-html="every.artSummary"
        ></div>
        <ul class="icon">
          <li @click.stop="clickFn('收藏')">
            <img
              v-if="every.isCollect"
              src="@/assets/img/qietu/sc.png"
              alt=""
            />
            <img v-else src="@/assets/img/qietu/kongxin.png" alt="" />
            <span>收藏</span>
          </li>
          <li
            v-for="(item, index) in getIconList"
            :key="index"
            @click.stop="clickFn(item)"
          >
            <img v-lazy="item.iconSrc" alt="" />
            <span>{{ item.iconTitle }}</span>
          </li>
          <li class="share">
            <img src="@/assets/img/qietu/share.png" alt="" />
            <div>分享</div>
            <ul class="share_box">
              <div class="sanjiao"></div>
              <li @mouseover.stop="weChat" class="weChat">
                <img src="@/assets/img/details/WeChat.png" alt="" />
                <div>微信</div>
                <div
                  :id="`WXqrcode${curcer}`"
                  :ref="`WXqrcode${curcer}`"
                  class="ma"
                ></div>
              </li>
              <li @click.stop="weibo">
                <img src="@/assets/img/details/weiBo.png" alt="" />
                <div>新浪微博</div>
              </li>
              <li @mouseover.stop="qq" class="qq">
                <img src="@/assets/img/details/QQ.png" alt="" />
                <div>QQ</div>
                <div
                  :id="`QQqrcode${curcer}`"
                  :ref="`QQqrcode${curcer}`"
                  class="ma"
                ></div>
              </li>
              <li @click.stop="space">
                <img src="@/assets/img/details/qqspace.png" alt="" />
                <div>QQ空间</div>
              </li>
            </ul>
          </li>
        </ul>
      </template>
    </div>
    <!-- 学术专著 -->
    <div class="item-img" v-else-if="every.articleType === 2">
      <div
        class="left"
        style="
          display: flex;
          justify-content: center;
          align-items: center;
          width: 150px;
          height: 150px;
          background: #f4f4f4;
        "
      >
        <img
          v-if="every.cover"
          v-lazy="$global.imgUrl + every.cover"
          alt=""
          style="width: 100%; height: 100%; object-fit: contain"
        />
        <img
          v-else
          v-lazy="require('@/assets/img/qietu/zz_default.png')"
          alt=""
          style="width: 80%; height: 80%; object-fit: contain"
        />
      </div>
      <div class="right" style="width: 680px; flex: 1">
        <h2 class="title" @click="handleClick">
          <span class="column" v-for="(v, i) in every.channelidsStr" :key="i"
            >[{{ v }}]</span
          >
          <span class="h2-title" v-html="every.title"></span>
        </h2>
        <div class="info">
          <span class="author" v-if="every.author">{{ every.author }}</span>
          <span
            class="author"
            :style="item.authorType === 0 ? 'cursor: pointer;' : ''"
            v-for="item in every.authorResultList"
            :key="item.articleId"
            @click="toAuthor(every, item.authorId, false, item.authorType)"
            >{{ item.authorName }}</span
          >
          <span class="time">{{ every.journalsYear }}</span>
          <span class="press">{{ every.periodical }}</span>
        </div>
        <div class="content" v-if="every.artSummary">
          {{ $global.matchReg(every.artSummary) }}
        </div>
        <ul class="icon">
          <li class="share">
            <img src="@/assets/img/qietu/share.png" alt="" />
            <div>分享</div>
            <ul class="share_box">
              <div class="sanjiao"></div>
              <li @mouseover.stop="weChat" class="weChat">
                <img src="@/assets/img/details/WeChat.png" alt="" />
                <div>微信</div>
                <!-- 定标 -->
                <div
                  :id="`WXqrcode${curcer}`"
                  :ref="`WXqrcode${curcer}`"
                  class="ma"
                ></div>
              </li>
              <li @click.stop="weibo">
                <img src="@/assets/img/details/weiBo.png" alt="" />
                <div>新浪微博</div>
              </li>
              <li @mouseover.stop="qq" class="qq">
                <img src="@/assets/img/details/QQ.png" alt="" />
                <div>QQ</div>
                <div
                  :id="`QQqrcode${curcer}`"
                  :ref="`QQqrcode${curcer}`"
                  class="ma"
                ></div>
              </li>
              <li @click.stop="space">
                <img src="@/assets/img/details/qqspace.png" alt="" />
                <div>QQ空间</div>
              </li>
            </ul>
          </li>
          <li @click.stop="clickFn('收藏')">
            <img
              v-if="every.isCollect"
              src="@/assets/img/qietu/sc.png"
              alt=""
            />
            <img v-else src="@/assets/img/qietu/kongxin.png" alt="" />
            <span>收藏</span>
          </li>
          <!-- <li @click.stop="downPdf(every.articleType, every.articleId)">
            <img src="@/assets/img/qietu/down.png" alt="" />
            <span>下载</span>
          </li>
          <Button
            class="readBtn"
            @click.stop="read(every.articleType, every.articleId)"
            v-throttleClick
          >
            <img src="@/assets/img/qietu/write.png" alt="" />
            <span>在线阅读</span>
          </Button> -->
        </ul>
      </div>
    </div>
    <!-- 中文资讯 -->
    <div class="item-img" v-else-if="every.articleType === 5">
      <div class="left zixun-img" v-if="every.cover">
        <img :src="$global.imgUrl + every.cover" alt="" />
      </div>
      <div class="zixun">
        <h2 class="title" @click="handleClick">
          <span class="topping" v-if="every.topping == 1">{{
            every.topping == 1 ? "置顶" : ""
          }}</span>
          <span class="column" v-for="(v, i) in every.channelidsStr" :key="i"
            >[{{ v }}]</span
          >
          <span class="h2-title" v-html="every.title"></span>
          <span class="classificationName" v-if="every.classificationName">{{
            every.classificationName
          }}</span>
        </h2>
        <div class="createName">
          <span style="cursor: pointer" @click="toAuthor(every)">{{
            every.periodical
          }}</span>
          <!-- every.createTime返回时间戳 -->
          <span>{{ getCreateTime }}</span>
        </div>
        <div class="address">{{ every.firstAuthorUnit }}</div>
        <div class="content" v-html="every.artSummary"></div>
        <ul class="icon">
          <li @click.stop="clickFn('收藏')">
            <img
              v-if="every.isCollect"
              src="@/assets/img/qietu/sc.png"
              alt=""
            />
            <img v-else src="@/assets/img/qietu/kongxin.png" alt="" />
            <span>收藏</span>
          </li>
          <li class="share">
            <img src="@/assets/img/qietu/share.png" alt="" />
            <div>分享</div>
            <ul class="share_box">
              <div class="sanjiao"></div>
              <li @mouseover.stop="weChat" class="weChat">
                <img src="@/assets/img/details/WeChat.png" alt="" />
                <div>微信</div>
                <div
                  :id="`WXqrcode${curcer}`"
                  :ref="`WXqrcode${curcer}`"
                  class="ma"
                ></div>
              </li>
              <li @click.stop="weibo">
                <img src="@/assets/img/details/weiBo.png" alt="" />
                <div>新浪微博</div>
              </li>
              <li @mouseover.stop="qq" class="qq">
                <img src="@/assets/img/details/QQ.png" alt="" />
                <div>QQ</div>
                <div
                  :id="`QQqrcode${curcer}`"
                  :ref="`QQqrcode${curcer}`"
                  class="ma"
                ></div>
              </li>
              <li @click.stop="space">
                <img src="@/assets/img/details/qqspace.png" alt="" />
                <div>QQ空间</div>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
    <!-- 万商数据 -->
    <div class="item-img" v-else-if="every.articleType === 6">
      <div class="left" v-if="every.cover" style="width: 120px; height: 170px">
        <img
          v-lazy="$global.imgUrl + every.cover"
          alt=""
          style="width: 120px; height: 170px"
        />
      </div>
      <div class="right">
        <h2 class="title" @click="handleClick">
          <span class="topping" v-if="every.topping == 1">{{
            every.topping == 1 ? "置顶" : ""
          }}</span>
          <span class="column" v-for="(v, i) in every.channelidsStr" :key="i"
            >[{{ v }}]</span
          >
          <span class="h2-title" v-html="every.title"></span>
          <span class="classificationName" v-if="every.classificationName">{{
            every.classificationName
          }}</span>
        </h2>
        <div class="address">{{ every.firstAuthorUnit }}</div>
        <div class="content" v-if="every.artSummary">
          {{ every.artSummary }}
        </div>
        <ul class="icon" style="margin-top: 60px">
          <li @click.stop="clickFn('收藏')">
            <img
              v-if="every.isCollect"
              src="@/assets/img/qietu/sc.png"
              alt=""
            />
            <img v-else src="@/assets/img/qietu/kongxin.png" alt="" />
            <span>收藏</span>
          </li>
          <li
            v-for="(item, index) in getIconList"
            :key="index"
            @click.stop="clickFn(item)"
          >
            <img v-lazy="item.iconSrc" alt="" />
            <span>{{ item.iconTitle }}</span>
          </li>
          <li class="share">
            <img src="@/assets/img/qietu/share.png" alt="" />
            <div>分享</div>
            <ul class="share_box">
              <div class="sanjiao"></div>
              <li @mouseover.stop="weChat" class="weChat">
                <img src="@/assets/img/details/WeChat.png" alt="" />
                <div>微信</div>
                <div
                  :id="`WXqrcode${curcer}`"
                  :ref="`WXqrcode${curcer}`"
                  class="ma"
                ></div>
              </li>
              <li @click.stop="weibo">
                <img src="@/assets/img/details/weiBo.png" alt="" />
                <div>新浪微博</div>
              </li>
              <li @mouseover.stop="qq" class="qq">
                <img src="@/assets/img/details/QQ.png" alt="" />
                <div>QQ</div>
                <div
                  :id="`QQqrcode${curcer}`"
                  :ref="`QQqrcode${curcer}`"
                  class="ma"
                ></div>
              </li>
              <li @click.stop="space">
                <img src="@/assets/img/details/qqspace.png" alt="" />
                <div>QQ空间</div>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
    <!-- 搜索列表学术会议 -->
    <div class="item-img" v-else-if="every.articleType === 8">
      <div class="left" v-if="every.cover" style="width: 150px; height: 150px">
        <img
          v-lazy="$global.imgUrl + every.cover"
          alt=""
          style="
            width: 100%;
            height: 100%;
            object-fit: contain;
            background-color: #f4f4f4;
          "
        />
      </div>
      <div class="right" style="flex: 1">
        <h2 class="title" @click="goDetail">
          <span class="h2-title" v-html="every.title"></span>
        </h2>
        <div class="unit-box">
          <img src="@/assets/img/qietu/meetIcon.png" alt="" />
          <span style="color: #3c4f83; font-weight: bold">主办单位：</span>
          <span class="unitText" v-for="v in every.organizerList" :key="v.id"
            >{{ v.name }}
          </span>
        </div>
        <div class="tiem-box">
          <div style="margin-right: 37px">
            <img src="@/assets/img/qietu/meetIcon2.png" alt="" />
            <span style="color: #3c4f83; font-weight: bold">时间：</span>
            <span>{{ every.betweenBeginTime.slice(0, 10) }}</span>
          </div>
          <div>
            <img src="@/assets/img/qietu/meetIcon1.png" alt="" />
            <span style="color: #3c4f83; font-weight: bold">地点：</span>
            <span>{{ every.addr }}</span>
          </div>
        </div>
        <ul class="icon" style="margin: 13px 0 5px">
          <li @click.stop="collect(every)">
            <img
              v-if="every.isCollect"
              src="@/assets/img/qietu/sc.png"
              alt=""
            />
            <img v-else src="@/assets/img/qietu/kongxin.png" alt="" />
            <span>收藏</span>
          </li>
          <li class="share">
            <img src="@/assets/img/qietu/share.png" alt="" />
            <div>分享</div>
            <ul class="share_box">
              <div class="sanjiao"></div>
              <li @mouseover.stop="weChat" class="weChat">
                <img src="@/assets/img/details/WeChat.png" alt="" />
                <div>微信</div>
                <div
                  :id="`WXqrcode${curcer}`"
                  :ref="`WXqrcode${curcer}`"
                  class="ma"
                ></div>
              </li>
              <li @click.stop="weibo">
                <img src="@/assets/img/details/weiBo.png" alt="" />
                <div>新浪微博</div>
              </li>
              <li @mouseover.stop="qq" class="qq">
                <img src="@/assets/img/details/QQ.png" alt="" />
                <div>QQ</div>
                <div
                  :id="`QQqrcode${curcer}`"
                  :ref="`QQqrcode${curcer}`"
                  class="ma"
                ></div>
              </li>
              <li @click.stop="space">
                <img src="@/assets/img/details/qqspace.png" alt="" />
                <div>QQ空间</div>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
    <!-- 课程列表 -->
    <div class="item-img" v-else-if="every.articleType === 9">
      <div class="left" v-if="every.cover" style="width: 268px; height: 150px">
        <img
          v-lazy="$global.imgUrl + every.cover"
          alt=""
          style="width: 268px; height: 150px"
        />
      </div>
      <div class="right">
        <h2 class="title" @click="handleClick">
          <span class="column" v-for="(v, i) in every.channelidsStr" :key="i"
            >[{{ v }}]</span
          >
          <span class="h2-title" v-html="every.title"></span>
          <span class="course_price">{{
            every.articleAbstract.saleType == 0
              ? "免费"
              : "¥" + every.articleAbstract.salePrice
          }}</span>
        </h2>
        <div class="personal">
          <div class="anther">
            发布时间：{{ every.articleAbstract.auditStatusTime.slice(0, 10) }}
          </div>
        </div>
        <div class="personal">
          <div class="anther">{{ every.publisher }}</div>
        </div>
        <ul class="icon" style="margin-top: 25px">
          <li @click.stop="clickFn('收藏')">
            <img
              v-if="every.isCollect"
              src="@/assets/img/qietu/sc.png"
              alt=""
            />
            <img v-else src="@/assets/img/qietu/kongxin.png" alt="" />
            <span>收藏</span>
          </li>
          <li class="share">
            <img src="@/assets/img/qietu/share.png" alt="" />
            <div>分享</div>
            <ul class="share_box">
              <div class="sanjiao"></div>
              <li @mouseover.stop="weChat" class="weChat">
                <img src="@/assets/img/details/WeChat.png" alt="" />
                <div>微信</div>
                <div
                  :id="`WXqrcode${curcer}`"
                  :ref="`WXqrcode${curcer}`"
                  class="ma"
                ></div>
              </li>
              <li @click.stop="weibo">
                <img src="@/assets/img/details/weiBo.png" alt="" />
                <div>新浪微博</div>
              </li>
              <li @mouseover.stop="qq" class="qq">
                <img src="@/assets/img/details/QQ.png" alt="" />
                <div>QQ</div>
                <div
                  :id="`QQqrcode${curcer}`"
                  :ref="`QQqrcode${curcer}`"
                  class="ma"
                ></div>
              </li>
              <li @click.stop="space">
                <img src="@/assets/img/details/qqspace.png" alt="" />
                <div>QQ空间</div>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
    <!-- 列表学术会议 -->
    <div class="item-img" v-else>
      <div class="left" v-if="every.cover" style="width: 150px; height: 150px">
        <img
          v-lazy="$global.imgUrl + every.cover"
          alt=""
          style="
            width: 100%;
            height: 100%;
            object-fit: contain;
            background-color: #f4f4f4;
          "
        />
      </div>
      <div class="right" style="flex: 1; overflow: hidden">
        <h2 class="title" @click="goDetail">
          <span class="h2-title" v-html="every.title"></span>
        </h2>
        <div class="unit-box">
          <img src="@/assets/img/qietu/meetIcon.png" alt="" />
          <span style="color: #3c4f83; font-weight: bold">主办单位：</span>
          <span
            class="unitText"
            v-for="v in every.orgs.filter((item) => item.type === 2)"
            :key="v.id"
            >{{ v.name }}
          </span>
        </div>
        <div class="tiem-box">
          <div style="margin-right: 37px">
            <img src="@/assets/img/qietu/meetIcon2.png" alt="" />
            <span style="color: #3c4f83; font-weight: bold">时间：</span>
            <span>{{ every.beginTime.slice(0, 10) }}</span>
          </div>
          <div>
            <img src="@/assets/img/qietu/meetIcon1.png" alt="" />
            <span style="color: #3c4f83; font-weight: bold">地点：</span>
            <span
              >{{ every.province }} {{ every.city }} {{ every.address }}</span
            >
          </div>
        </div>
        <ul class="icon" style="margin: 13px 0 5px">
          <li @click.stop="collect(every, true)">
            <img v-if="every.collect" src="@/assets/img/qietu/sc.png" alt="" />
            <img v-else src="@/assets/img/qietu/kongxin.png" alt="" />
            <span>收藏</span>
          </li>
          <li class="share">
            <img src="@/assets/img/qietu/share.png" alt="" />
            <div>分享</div>
            <ul class="share_box">
              <div class="sanjiao"></div>
              <li @mouseover.stop="weChat" class="weChat">
                <img src="@/assets/img/details/WeChat.png" alt="" />
                <div>微信</div>
                <div
                  :id="`WXqrcode${curcer}`"
                  :ref="`WXqrcode${curcer}`"
                  class="ma"
                ></div>
              </li>
              <li @click.stop="weibo">
                <img src="@/assets/img/details/weiBo.png" alt="" />
                <div>新浪微博</div>
              </li>
              <li @mouseover.stop="qq" class="qq">
                <img src="@/assets/img/details/QQ.png" alt="" />
                <div>QQ</div>
                <div
                  :id="`QQqrcode${curcer}`"
                  :ref="`QQqrcode${curcer}`"
                  class="ma"
                ></div>
              </li>
              <li @click.stop="space">
                <img src="@/assets/img/details/qqspace.png" alt="" />
                <div>QQ空间</div>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
    <Modal
      v-model="qrCodeModal"
      title="手机查看完整会议内容"
      class=""
      @on-cancel="qrCodeModal = false"
      :footer-hide="true"
    >
      <div style="width: 200px; height: 200px; margin: 20px auto">
        <div id="qrcodeArea" ref="qrcodeArea"></div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
import QRCode from "qrcodejs2";
export default {
  props: {
    every: {
      type: Object,
      required: true,
    },
    curcer: {
      type: String,
    },
    banTo: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    getIconList() {
      let arr = this.iconList.slice();

      return arr.splice(0, 2);
    },
    getCreateTime() {
      if (!this.every.originalPublishTime) return "";
      if (isNaN(Number(this.every.originalPublishTime))) {
        return this.every.originalPublishTime.slice(0, 11);
      } else {
        return this.$global.transferDay(this.every.originalPublishTime);
      }
    },
    ...mapState(["hasLogin", "token"]),
  },
  data() {
    return {
      qrCodeModal: false,
      WXurl: "",
      QQurl: "",
      createTime: "",
      iconList: [
        {
          iconSrc: require("@/assets/img/qietu/down.png"),
          iconTitle: "下载",
        },
        {
          iconSrc: require("@/assets/img/qietu/write.png"),
          iconTitle: "在线阅读",
        },
        {
          iconSrc: require("@/assets/img/qietu/th.png"),
          iconTitle: "同行评议",
        },
        {
          iconSrc: require("@/assets/img/qietu/th.png"),
          iconTitle: "被引文献",
        },
      ],
    };
  },

  methods: {
    toAuthor(obj, id, isJournal = false, authorType) {
      if (!this.banTo || authorType === 1) return; // 除了论文列表页其他地方都不让跳转作者 || 专著如果作者是其他类型 不让跳转
      let routeUrl;
      if (obj.articleType === 5) {
        // 中文资讯跳转
        switch (obj.userType) {
          case 0: // 作者百家跳转
            routeUrl = this.$router.resolve({
              path: `/bjzxdetail`,
              query: {
                title: "百家在线",
                id: obj.createUser,
              },
            });
            break;
          case 1: // 作者百科跳转
            routeUrl = this.$router.resolve({
              path: `/bkzxdetail`,
              query: {
                title: "百科在线",
                id: obj.companyId,
              },
            });
            break;
          case 2: // 作者机构跳转
            routeUrl = this.$router.resolve({
              path: `/jghdetail`,
              query: {
                title: "机构号",
                id: obj.companyId,
              },
            });
            break;
        }
      } else {
        // 论文跳转
        if (isJournal) {
          // 是否百科
          routeUrl = this.$router.resolve({
            path: `/bkzxdetail`,
            query: {
              title: "百科在线",
              id: id,
            },
          });
        } else {
          routeUrl = this.$router.resolve({
            path: `/bjzxdetail`,
            query: {
              title: "百家在线",
              id: id,
            },
          });
        }
      }
      window.open(routeUrl.href, "_blank");
    },
    handleClick() {
      if (this.every.articleType === 0 && this.every.type === 0) {
        // 跳转静态页面首页
        window.open(
          `${this.$global.SeoUrl}thesisDetail?type=0&id=${this.every.articleId}`
        );
      } else {
        this.$emit("itemClick", this.every);
      }
    },
    goDetail() {
      window.open(
        this.$global.meetingH5Url +
          `pagesModule/meetingDetails/index?type=8&id=${
            this.every.goodsId || this.every.articleId
          }`,
        "_self"
      );
    },
    async read(type, id) {
      if (!this.hasLogin) {
        this.$bus.$emit("showModel", true);
        return;
      }
      let obj = {
        articleId: id,
        articleType: type,
      };
      let res = await this.$apis.mainServe.hasFile(obj);
      if (res.resultCode !== "200") {
        this.$Message.error("没有文献");
        return false;
      }
      window.open(
        this.$apis.mainServe.readUrl +
          "?articleId=" +
          id +
          "&articleType=" +
          type +
          "&token=" +
          this.token
      );
    },
    clickFn(item) {
      if (item === "收藏") {
        this.collect(this.every);
      } else if (item.iconTitle === "下载") {
        this.downPdf(this.every.articleType, this.every.articleId);
      } else if (item.iconTitle === "在线阅读") {
        this.read(this.every.articleType, this.every.articleId);
      }
    },
    // 收藏
    async collect(every, isMeeting = false) {
      // isMeeting 代表是不是会议列表
      if (!this.hasLogin) {
        this.$bus.$emit("showModel", true);
        return;
      }
      let obj = {
        action: isMeeting ? (every.collect ? 0 : 1) : every.isCollect ? 0 : 1,
        articleId: isMeeting ? every.id : every.articleId,
        articleType: isMeeting ? 8 : this.every.articleType,
      };
      await this.$apis.recomendServe.CollectItem(obj);
      await this.TFCollect(every, isMeeting);
    },
    async TFCollect(every, isMeeting) {
      // isMeeting 代表是不是会议列表
      let obj = {
        articleId: isMeeting ? this.every.id : this.every.articleId,
        articleType: isMeeting ? 8 : this.every.articleType,
      };
      let res = await this.$apis.recomendServe.isCollect(obj);
      if (isMeeting) {
        every.collect = res.isCollect;
      } else {
        every.isCollect = res.isCollect;
      }
    },
    async downPdf(type, id) {
      if (!this.hasLogin) {
        this.$bus.$emit("showModel", true);
        return;
      }
      let obj = {
        articleId: id,
        articleType: type,
      };
      let res = await this.$apis.mainServe.hasFile(obj);
      if (res.resultCode !== "200") {
        this.$Message.error("没有文献");
        return false;
      }
      window.open(
        this.$apis.mainServe.download +
          "?articleId=" +
          id +
          "&articleType=" +
          type +
          "&token=" +
          this.token
      );
    },
    getUrl(isPC = false) {
      let url = "";
      if (this.every.articleType === 0) {
        // 论文
        url =
          (isPC
            ? this.$global.url1.substring(0, this.$global.url1.indexOf("a"))
            : this.$global.url1) +
          `${isPC ? "thesisDetail" : "thesisDetail"}?type=${
            this.every.articleType
          }&id=${this.every.articleId}`;
      } else if (this.every.articleType == 2) {
        // 专著
        url =
          this.$global.url1 +
          `concentrationDetails?type=${this.every.articleType}&id=${this.every.articleId}`;
      } else if (this.every.articleType === 6) {
        // 行业报告
        url =
          this.$global.url1 +
          `dataDetails?type=${this.every.articleType}&id=${this.every.articleId}`;
      } else if (this.every.articleType === 5) {
        // 资讯详情
        url =
          this.$global.url1 +
          `msgDetails?type=${this.every.articleType}&id=${this.every.articleId}`;
      } else if (this.every.articleType === 9) {
        // 资讯详情
        url =
          this.$global.url1 +
          `courseDetails?type=${this.every.articleType}&id=${this.every.articleId}`;
      } else {
        // 学术会议详情
        url =
          this.$global.meetingH5Url +
          `pagesModule/meetingDetails/index?type=8&id=${
            this.every.articleId ? this.every.articleId : this.every.id
          }`;
      }
      return url;
    },
    weChat() {
      if (this.WXurl !== "") return;
      this.WXurl = this.getUrl();
      // 使用$nextTick确保数据渲染
      this.$nextTick(() => {
        this.WXcrateQrcode();
      });
    },
    WXcrateQrcode() {
      this.qr = new QRCode("WXqrcode" + this.curcer, {
        width: 150,
        height: 150, // 高度
        text: this.WXurl, // 二维码内容
      });
    },
    QQcrateQrcode() {
      this.qr = new QRCode("QQqrcode" + this.curcer, {
        width: 150,
        height: 150, // 高度
        text: this.QQurl, // 二维码内容
      });
    },
    qq() {
      if (this.QQurl !== "") return;
      this.QQurl = this.getUrl();
      // 使用$nextTick确保数据渲染
      this.$nextTick(() => {
        this.QQcrateQrcode();
      });
    },
    weibo() {
      let url = encodeURIComponent(this.getUrl(true));
      let srcUrl = "";
      this.every.cover
        ? (srcUrl = `pic=${this.$global.imgUrl + this.every.cover}&`)
        : (srcUrl = "");
      window.open(
        `https://service.weibo.com/share/share.php?${srcUrl}url=${url}&title=${this.every.title}`
      );
    },
    space() {
      let url = encodeURIComponent(this.getUrl(true));
      let srcUrl = "";
      this.every.cover
        ? (srcUrl = `pics=${this.$global.imgUrl + this.every.cover}&`)
        : (srcUrl = "");
      window.open(
        `https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?${srcUrl}url=${url}&title=${this.every.title}`
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.item-container {
  box-sizing: border-box;
  margin-top: 0px;
  padding: 26px 43px 30px 26px;
  width: 100%;
  // min-height: 226px; // 论文搜索列表
  background-color: #ffffff;
  border: 1px solid #a3cbe7;
  border-radius: 10px;
  overflow: hidden;
  &:not(:first-child) {
    margin-top: 6px;
  }
  &:hover {
    box-shadow: 0px 13px 15px 1px rgb(22 26 100 / 13%);
  }
  .title {
    font-size: 18px;
    cursor: pointer;
    .column {
      color: #0491ae;
      font-weight: lighter;
      vertical-align: middle;
    }
    .h2-title {
      vertical-align: middle;
      color: #263d78;
      &::v-deep p {
        display: inline-block !important;
      }
    }
    .topping {
      display: inline-block;
      width: 35px;
      height: 19px;
      margin-right: 7px;
      text-align: center;
      line-height: 19px;
      background-color: red;
      color: #fff;
      vertical-align: middle;
      border-radius: 5px;
      font-size: 14px;
      font-weight: lighter;
      white-space: nowrap;
    }
    .classificationName {
      display: inline-block;
      text-align: center;
      line-height: 18px;
      margin-left: 16px;
      display: inline-block;
      color: #263d78;
      vertical-align: middle;
      font-size: 12px;
      white-space: nowrap;
      font-weight: lighter;
      min-width: 60px;
      height: 18px;
      background: #d8dbfe;
      opacity: 0.66;
      border-radius: 8px;
      padding: 0 10px;
    }
  }
  .course_price {
    margin-left: 8px;
    padding: 0 6px;
    height: 17px;
    background: #ff00002e;
    border-radius: 2px;
    font-size: 12px;
    color: #ff0000;
    line-height: 17px;
  }
  .period {
    width: 400px;
    text-align: right;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
  }
  .personal {
    display: flex;
    justify-content: space-between;
    margin-top: 15px;
    font-size: 12px;
    color: #666666;
    .anther {
      width: 279px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      li {
        display: inline;
        margin-right: 10px;
      }
    }
  }
  .icon {
    // position: absolute;
    // bottom: 0px;
    // left: 0;
    display: flex;
    margin-top: 20px;
    height: 37px;
    background: #ffffff;
    li {
      border: 1px solid #dfe8f2;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      font-weight: 400;
      color: #666666;
      padding: 10px;
      box-sizing: border-box;
      cursor: pointer;
      &:not(:last-child) {
        border-right: none;
      }
      img {
        width: 20px;
        height: 20px;
        margin-right: 6px;
      }
    }
    .readBtn {
      border: 1px solid #dfe8f2;
      border-radius: 0;
      height: 100%;
      img {
        width: 20px;
        height: 20px;
        margin-right: 6px;
        vertical-align: middle;
      }
      &:focus {
        box-shadow: none !important;
      }
    }
    .share:hover {
      .share_box {
        display: block;
      }
    }
    .share {
      position: relative;
      .share_box {
        cursor: pointer;
        display: none;
        right: -133px;
        top: -130px;
        position: absolute;
        width: 133px;
        height: 167px;
        background: #ffffff;
        box-shadow: 3px 1px 7px 0px rgba(8, 8, 64, 0.23);
        border-radius: 10px;
        .weChat:hover {
          .ma {
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 99;
          }
        }

        .weChat {
          position: relative;
          .ma {
            display: none;
            left: 123px !important;
            position: absolute !important;
            width: 200px !important;
            top: -10px !important;
            height: 167px !important;
            background: white !important;
            box-shadow: 3px 1px 7px 0px rgba(8, 8, 64, 0.23);
            border-radius: 10px;
          }
        }
        .qq:hover {
          .ma {
            display: flex;
            justify-content: center;
            align-items: center;
          }
        }
        .qq {
          position: relative;
          .ma {
            display: none;
            left: 123px !important;
            position: absolute !important;
            width: 200px !important;
            top: -90px !important;
            height: 167px !important;
            background: white !important;
            box-shadow: 3px 1px 7px 0px rgba(8, 8, 64, 0.23);
            border-radius: 10px;
          }
        }
        li {
          border: none;
          margin-top: 10px;
          margin-bottom: 0px;
          //display: flex;
          flex-wrap: nowrap;
          //background: pink;
          justify-content: center;
          align-items: center;
          width: 133px;
          height: 30px;

          div {
            width: 60px;
            //background: yellow;
            margin-left: 10px;
          }
          img {
            width: 20px;
            height: 20px;
          }
        }
        .sanjiao {
          width: 0;
          height: 0;
          border-top: 3px solid transparent;
          border-right: 6px solid #fff;
          position: absolute;
          top: 50%;
          margin-top: -3px;
          left: -6px;
          border-bottom: 3px solid transparent;

          //background: pink;
        }
      }
    }
  }
  .content {
    width: 100%;
    height: 40px;
    margin-top: 10px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }
  .item-img {
    position: relative;
    display: flex;
    width: 100%;
    height: 100%;
    .left {
      width: 240px;
      height: 165px;
      margin-right: 15px;
      margin-top: 7px;
      img {
        width: 240px;
        height: 165px;
      }
    }
    .zixun-img {
      width: 150px;
      height: 150px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .right {
      position: relative;
      display: flex;
      flex-direction: column;
      width: 857px;
      .info {
        margin: 9px 0;
        font-size: 12px;
        color: #666666;
        span {
          margin-right: 5px;
        }
      }
      .createName {
        margin: 14px 0 14px 0;
        font-size: 12px;
        color: #666666;
      }
      .unit-box {
        margin: 20px 0;
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        img {
          margin-right: 5px;
          width: 20px;
          height: 20px;
          vertical-align: middle;
        }
        span {
          vertical-align: middle;
        }
      }
      .tiem-box {
        display: flex;
        img {
          margin-right: 5px;
          width: 20px;
          height: 20px;
          vertical-align: middle;
        }
        span {
          vertical-align: middle;
        }
      }
    }
    .zixun {
      position: relative;
      display: flex;
      flex-direction: column;
      min-width: 857px;
      width: 100%;
      flex: 1;
      .info {
        margin: 16px 0;
        font-size: 12px;
        color: #666666;
        span {
          margin: 0 5px;
        }
      }
      .createName {
        display: flex;
        justify-content: space-between;
        margin: 14px 0 14px 0;
        font-size: 12px;
        color: #666666;
      }
    }
  }
  .item-no-img {
    position: relative;
    width: 100%;
    height: 100%;
    .personal {
      margin-top: 15px;
    }
    .address {
      margin-top: 30px;
    }
    .origin-periods {
      margin-top: 12px;
      .period {
        margin-right: 20px;
      }
    }
  }
}
</style>
